import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { SeoPageLayout } from '@/components/layout/SeoPageLayout';
import { Link } from '@/components/links';
import { Button, Hint, Paragraph, SemiBold, UnorderedList, FAQs } from '@/components/seo';
import { LINKS } from '@/constants/links';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { NumericRange } from '@/types/range';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
interface Props extends IntlProps {
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(150);
  const {
    menuPromoBanners
  } = t0;
  usePageView("seo-payment-online");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["seoPaymentOnline", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = Array.from({
      length: 4
    }, (_, index) => {
      const faqIndex = index + 1 as NumericRange<1, 4>;
      return {
        question: t(`seoPaymentOnline:sections.faqs.${faqIndex}.question`),
        answer: t(`seoPaymentOnline:sections.faqs.${faqIndex}.answer`)
      };
    });
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const faqsData = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t("seoPaymentOnline:seo.title");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("seoPaymentOnline:seo.description");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = {
      title: t3,
      description: t4
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  let t8;
  if ($[11] !== t) {
    t7 = <Trans t={t} i18nKey="seoPaymentOnline:header.title">{t6}</Trans>;
    t8 = t("seoPaymentOnline:header.intro");
    $[11] = t;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <p>{t8}</p>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t("seoPaymentOnline:header.button");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = LINKS();
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10) {
    t12 = {
      label: t10,
      to: t11.registration
    };
    $[19] = t10;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t("seoPaymentOnline:sections.1.title");
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t) {
    t15 = <Trans t={t} i18nKey="seoPaymentOnline:sections.1.content" components={t14} />;
    $[24] = t;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t13 || $[27] !== t15) {
    t16 = {
      title: t13,
      content: t15
    };
    $[26] = t13;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t) {
    t17 = t("seoPaymentOnline:sections.2.title");
    $[29] = t;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t) {
    t19 = <Trans t={t} i18nKey="seoPaymentOnline:sections.2.content" components={t18} />;
    $[32] = t;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t17 || $[35] !== t19) {
    t20 = {
      title: t17,
      content: t19
    };
    $[34] = t17;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t) {
    t21 = t("seoPaymentOnline:sections.3.title");
    $[37] = t;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  let t23;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Paragraph />;
    t23 = <SemiBold />;
    $[39] = t22;
    $[40] = t23;
  } else {
    t22 = $[39];
    t23 = $[40];
  }
  let t24;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = {
      paragraph: t22,
      semibold: t23,
      link1: <Link analyticsParam="paymentOnlineLinkDeferredPayment" testId="paymentOnlineLinkDeferredPayment" to={LINKS().aboutDeferredPayment} />
    };
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== t) {
    t25 = <Trans t={t} i18nKey="seoPaymentOnline:sections.3.content" components={t24} />;
    $[42] = t;
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] !== t21 || $[45] !== t25) {
    t26 = {
      title: t21,
      content: t25
    };
    $[44] = t21;
    $[45] = t25;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  let t27;
  if ($[47] !== t) {
    t27 = t("seoPaymentOnline:sections.4.title");
    $[47] = t;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[49] = t28;
  } else {
    t28 = $[49];
  }
  let t29;
  if ($[50] !== t) {
    t29 = <Trans t={t} i18nKey="seoPaymentOnline:sections.4.content" components={t28} />;
    $[50] = t;
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  let t30;
  if ($[52] !== t) {
    t30 = <Hint text={<Trans t={t} i18nKey="seoPaymentOnline:sections.4.hint" />} />;
    $[52] = t;
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  let t31;
  if ($[54] !== t29 || $[55] !== t30) {
    t31 = <>{t29}{t30}</>;
    $[54] = t29;
    $[55] = t30;
    $[56] = t31;
  } else {
    t31 = $[56];
  }
  let t32;
  if ($[57] !== t27 || $[58] !== t31) {
    t32 = {
      title: t27,
      content: t31
    };
    $[57] = t27;
    $[58] = t31;
    $[59] = t32;
  } else {
    t32 = $[59];
  }
  let t33;
  if ($[60] !== t) {
    t33 = t("seoPaymentOnline:sections.5.title");
    $[60] = t;
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  let t34;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[62] = t34;
  } else {
    t34 = $[62];
  }
  let t35;
  if ($[63] !== t) {
    t35 = <Trans t={t} i18nKey="seoPaymentOnline:sections.5.content" components={t34} />;
    $[63] = t;
    $[64] = t35;
  } else {
    t35 = $[64];
  }
  let t36;
  if ($[65] !== t33 || $[66] !== t35) {
    t36 = {
      title: t33,
      content: t35
    };
    $[65] = t33;
    $[66] = t35;
    $[67] = t36;
  } else {
    t36 = $[67];
  }
  let t37;
  if ($[68] !== t) {
    t37 = t("seoPaymentOnline:sections.6.title");
    $[68] = t;
    $[69] = t37;
  } else {
    t37 = $[69];
  }
  let t38;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = {
      paragraph: <Paragraph />
    };
    $[70] = t38;
  } else {
    t38 = $[70];
  }
  let t39;
  if ($[71] !== t) {
    t39 = <Trans t={t} i18nKey="seoPaymentOnline:sections.6.content" components={t38} />;
    $[71] = t;
    $[72] = t39;
  } else {
    t39 = $[72];
  }
  let t40;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = [...Array(3)];
    $[73] = t40;
  } else {
    t40 = $[73];
  }
  let t41;
  if ($[74] !== t) {
    t41 = <UnorderedList items={t40.map((__0, i) => {
      const transIndex = i + 1 as NumericRange<1, 3>;
      return <Trans key={i} t={t} i18nKey={`seoPaymentOnline:sections.6.list.${transIndex}`} components={{
        semibold: <SemiBold />
      }} />;
    })} />;
    $[74] = t;
    $[75] = t41;
  } else {
    t41 = $[75];
  }
  let t42;
  if ($[76] !== t39 || $[77] !== t41) {
    t42 = <>{t39}{t41}</>;
    $[76] = t39;
    $[77] = t41;
    $[78] = t42;
  } else {
    t42 = $[78];
  }
  let t43;
  if ($[79] !== t37 || $[80] !== t42) {
    t43 = {
      title: t37,
      content: t42
    };
    $[79] = t37;
    $[80] = t42;
    $[81] = t43;
  } else {
    t43 = $[81];
  }
  let t44;
  if ($[82] !== t) {
    t44 = t("seoPaymentOnline:sections.7.title");
    $[82] = t;
    $[83] = t44;
  } else {
    t44 = $[83];
  }
  let t45;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = {
      paragraph: <Paragraph />
    };
    $[84] = t45;
  } else {
    t45 = $[84];
  }
  let t46;
  if ($[85] !== t) {
    t46 = <Trans t={t} i18nKey="seoPaymentOnline:sections.7.content" components={t45} />;
    $[85] = t;
    $[86] = t46;
  } else {
    t46 = $[86];
  }
  let t47;
  if ($[87] !== t) {
    t47 = <Hint text={<Trans t={t} i18nKey="seoPaymentOnline:sections.7.hint" />} />;
    $[87] = t;
    $[88] = t47;
  } else {
    t47 = $[88];
  }
  let t48;
  if ($[89] !== t46 || $[90] !== t47) {
    t48 = <>{t46}{t47}</>;
    $[89] = t46;
    $[90] = t47;
    $[91] = t48;
  } else {
    t48 = $[91];
  }
  let t49;
  if ($[92] !== t44 || $[93] !== t48) {
    t49 = {
      title: t44,
      content: t48
    };
    $[92] = t44;
    $[93] = t48;
    $[94] = t49;
  } else {
    t49 = $[94];
  }
  let t50;
  if ($[95] !== t) {
    t50 = t("seoPaymentOnline:sections.8.title");
    $[95] = t;
    $[96] = t50;
  } else {
    t50 = $[96];
  }
  let t51;
  if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[97] = t51;
  } else {
    t51 = $[97];
  }
  let t52;
  if ($[98] !== t) {
    t52 = <Trans t={t} i18nKey="seoPaymentOnline:sections.8.content" components={t51} />;
    $[98] = t;
    $[99] = t52;
  } else {
    t52 = $[99];
  }
  let t53;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = LINKS();
    $[100] = t53;
  } else {
    t53 = $[100];
  }
  const t54 = t53.registration;
  let t55;
  if ($[101] !== t) {
    t55 = t("seoPaymentOnline:sections.8.button");
    $[101] = t;
    $[102] = t55;
  } else {
    t55 = $[102];
  }
  let t56;
  if ($[103] !== t55) {
    t56 = <Button analyticsParam="seoPaymentOnlineRegistrationLink" testId="seoPaymentOnlineRegistrationLink" to={t54} variant="primary">{t55}</Button>;
    $[103] = t55;
    $[104] = t56;
  } else {
    t56 = $[104];
  }
  let t57;
  if ($[105] !== t52 || $[106] !== t56) {
    t57 = <>{t52}{t56}</>;
    $[105] = t52;
    $[106] = t56;
    $[107] = t57;
  } else {
    t57 = $[107];
  }
  let t58;
  if ($[108] !== t50 || $[109] !== t57) {
    t58 = {
      title: t50,
      content: t57
    };
    $[108] = t50;
    $[109] = t57;
    $[110] = t58;
  } else {
    t58 = $[110];
  }
  let t59;
  if ($[111] !== t) {
    t59 = t("seoPaymentOnline:sections.9.title");
    $[111] = t;
    $[112] = t59;
  } else {
    t59 = $[112];
  }
  let t60;
  if ($[113] === Symbol.for("react.memo_cache_sentinel")) {
    t60 = {
      paragraph: <Paragraph />
    };
    $[113] = t60;
  } else {
    t60 = $[113];
  }
  let t61;
  if ($[114] !== t) {
    t61 = <Trans t={t} i18nKey="seoPaymentOnline:sections.9.content" components={t60} />;
    $[114] = t;
    $[115] = t61;
  } else {
    t61 = $[115];
  }
  let t62;
  if ($[116] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = [...Array(7)];
    $[116] = t62;
  } else {
    t62 = $[116];
  }
  let t63;
  if ($[117] !== t) {
    t63 = <UnorderedList items={t62.map((__1, i_0) => {
      const transIndex_0 = i_0 + 1 as NumericRange<1, 7>;
      return <Trans key={i_0} t={t} i18nKey={`seoPaymentOnline:sections.9.list.${transIndex_0}`} components={{
        semibold: <SemiBold />
      }} />;
    })} />;
    $[117] = t;
    $[118] = t63;
  } else {
    t63 = $[118];
  }
  let t64;
  if ($[119] !== t61 || $[120] !== t63) {
    t64 = <>{t61}{t63}</>;
    $[119] = t61;
    $[120] = t63;
    $[121] = t64;
  } else {
    t64 = $[121];
  }
  let t65;
  if ($[122] !== t59 || $[123] !== t64) {
    t65 = {
      title: t59,
      content: t64
    };
    $[122] = t59;
    $[123] = t64;
    $[124] = t65;
  } else {
    t65 = $[124];
  }
  let t66;
  if ($[125] !== t) {
    t66 = t("core:faqs.title");
    $[125] = t;
    $[126] = t66;
  } else {
    t66 = $[126];
  }
  let t67;
  if ($[127] !== faqsData) {
    t67 = <FAQs data={faqsData} />;
    $[127] = faqsData;
    $[128] = t67;
  } else {
    t67 = $[128];
  }
  let t68;
  if ($[129] !== t66 || $[130] !== t67) {
    t68 = {
      title: t66,
      content: t67
    };
    $[129] = t66;
    $[130] = t67;
    $[131] = t68;
  } else {
    t68 = $[131];
  }
  let t69;
  if ($[132] !== t16 || $[133] !== t20 || $[134] !== t26 || $[135] !== t32 || $[136] !== t36 || $[137] !== t43 || $[138] !== t49 || $[139] !== t58 || $[140] !== t65 || $[141] !== t68) {
    t69 = [t16, t20, t26, t32, t36, t43, t49, t58, t65, t68];
    $[132] = t16;
    $[133] = t20;
    $[134] = t26;
    $[135] = t32;
    $[136] = t36;
    $[137] = t43;
    $[138] = t49;
    $[139] = t58;
    $[140] = t65;
    $[141] = t68;
    $[142] = t69;
  } else {
    t69 = $[142];
  }
  let t70;
  if ($[143] !== menuPromoBanners || $[144] !== t12 || $[145] !== t5 || $[146] !== t69 || $[147] !== t7 || $[148] !== t9) {
    t70 = <SeoPageLayout menuPromoBanners={menuPromoBanners} seo={t5} title={t7} intro={t9} introButton={t12} sections={t69} />;
    $[143] = menuPromoBanners;
    $[144] = t12;
    $[145] = t5;
    $[146] = t69;
    $[147] = t7;
    $[148] = t9;
    $[149] = t70;
  } else {
    t70 = $[149];
  }
  return t70;
}
export const getStaticProps: GetStaticProps = async ctx => {
  const isAllowed = isAllowedRoute('platba-online');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'seoPaymentOnline']))
    }
  };
};